namespace $ {
	export class $mol_button_typed extends $mol_button {
	}
	
}

